import * as BasketUpdated from '@ori-events/basket-updated';

import type { UpdateEventType } from '../models';

export const dispatchBasketUpdatedEvent = (
  detail: BasketUpdated.Data,
  eventType: UpdateEventType = BasketUpdated.Name,
) => {
  const event = new CustomEvent<BasketUpdated.Data>(eventType, {
    detail,
  });
  window.dispatchEvent(event);
};

export default dispatchBasketUpdatedEvent;
